export enum USER_TYPE  {
    STUDENT = "student",
    MEMBER = "MEMBER"
}